export default __webpack_public_path__ + "static/carousell-os-car-valuation-consumer-protection-6e94419706922ce564305b9a15adeb35.svg";